// extracted by mini-css-extract-plugin
export default {"Content":"Layout_Content__gynaM","Padding":"Layout_Padding__y6n5A"};